import classNames from "classnames";
import React from "react";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";

export interface ScaleLockBracketProps {
  /** Whether uniform scale is currently active. */
  locked: boolean;
  /** Toggle handler. Click-through wiring is owned by the parent (TransformAccordion). */
  onToggle: () => void;
  /** Disable interaction (greys out the icon). */
  disabled?: boolean;
  /** Test id for the toggle button. */
  dataTestId?: string;
}

/**
 * Webflow-style scale lock bracket: a thin vertical bracket on the right of the
 * X and Y rows of the Scale transform, with a lock/unlock icon in the middle.
 * Click toggles `uniformScale` on the parent transform item. When locked, the
 * parent broadcasts X→Y so the two axes stay in lockstep.
 *
 * Pure presentational; positioning relative to the X/Y rows is handled in
 * transform-accordion.scss via grid placement.
 */
const ScaleLockBracket: React.FC<ScaleLockBracketProps> = ({ locked, onToggle, disabled, dataTestId }) => {
  return (
    <div
      className={classNames("scale-lock-bracket", {
        "scale-lock-bracket--locked": locked,
        "scale-lock-bracket--disabled": disabled
      })}
      aria-hidden={disabled ? "true" : undefined}
    >
      <span className="scale-lock-bracket__line scale-lock-bracket__line--top" />
      <button
        type="button"
        className="scale-lock-bracket__toggle"
        aria-label={locked ? "Unlock uniform scale" : "Lock uniform scale"}
        aria-pressed={locked}
        disabled={disabled}
        onClick={(e: React.MouseEvent): void => {
          e.stopPropagation();
          onToggle();
        }}
        data-testid={dataTestId}
      >
        <KuikaSvg name={locked ? "lock" : "lock-open"} width={12} height={12} />
      </button>
      <span className="scale-lock-bracket__line scale-lock-bracket__line--bottom" />
    </div>
  );
};

export default ScaleLockBracket;
